

























































import Vue from "vue";
import Component from "vue-class-component";
import QTableHeader from "@/common/qTableHeader.vue";
import QPaginate from "@/common/qPaginate.vue";
import PaginateModel from "@/model/paginate";
import { NewsNewsDTO } from "@/common/api/models/NewsNewsDTO";
import { NewsManagerService } from "@/common/api";
import EditNews from "@/pages/news/edit.vue";

@Component({
  name: "NewsIndex",
  components: {
    QTableHeader,
    QPaginate,
    EditNews,
  },
})
export default class NewsIndex extends Vue {
  public initSearch = {
    keyword: "",
    sort: "created_at",
    direction: "desc",
    perPage: 20,
    currentPage: 1,
  };
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public initHeaders = [
    { id: "created_at", name: "公開日", order: "desc" },
    { id: "category", name: "カテゴリ名", order: "" },
    { id: "context", name: "内容" },
    { id: "", name: "" },
  ];

  public headers = [];

  public editIndex = null;

  public newsList: NewsNewsDTO[] = [];

  mounted() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.filter();
  }

  public convertText(text) {
    return text.replace(/<[^>]*>/g, " ").replace(/&nbsp;/g, " ");
  }

  public filter(): void {
    let query = this.$router.currentRoute.query;
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    query = {
      ...this.initSearch,
      ...query,
    };
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query) {
    const result = await NewsManagerService.news(query);
    this.pagination = new PaginateModel({
      page: result.data.paginator.currentPage,
      pageCount: result.data.paginator.lastPages,
      start: result.data.paginator.currentPage,
      end: result.data.paginator.lastPages,
      count: result.data.paginator.total,
    });
    this.newsList = result.data.newsList;
  }

  public addNews() {
    (this.$refs.editNews as EditNews).show();
  }

  public editNews(news, index) {
    this.editIndex = index;
    (this.$refs.editNews as EditNews).show(news);
  }

  public clear() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.$router.replace({ query: {} });
    this.doSearch();
  }

  public closeEdited(news) {
    this.newsList.slice(this.editIndex, 1);
    this.newsList.splice(this.editIndex, 0, news);
  }
}
